
import { defineComponent } from 'vue'
import ALoader from '@/components/ALoader.vue'
import PostCreate from '@/components/Post/PostCreate.vue'
import { usePostListUiActions } from '@/composables/ui/uiActions'
import PostOldestList from '@/components/Post/PostOldestList.vue'
import PostNewestList from '@/components/Post/PostNewestList.vue'
import PostShowList from '@/components/Post/PostShowList.vue'
import PostBestList from '@/components/Post/PostBestList.vue'
import useTopic from '@/composables/topic/topic'
import PostListMenu from '@/components/Post/PostListMenu.vue'
import usePostsLoader from '@/composables/post/postLoader'
import usePostListMenu from '@/composables/ui/postListMenu'
import PostSaved from '@/components/Post/PostSaved.vue'
import PostRespondBanned from '@/components/Post/PostRespondBanned.vue'
import TopLoginBanner from '@/components/Post/TopLoginBanner.vue'
import TechnicalShutdown from '@/components/TechnicalShutdown.vue'
import useAppState from '@/composables/ui/ui'
import usePostSingleLoader from '@/composables/post/postSingleLoader'
import AButton from '@/components/Forms/AButton.vue'
import usePostList from '@/composables/post/postList'
import usePostCreate from '@/composables/post/postCreate'
import { useSubscribeTopic } from '@/composables/subscribers/subscribersManager'
import useConfiguration from '@/composables/configuration/configuration'
import useCurrentUser from '@/composables/user/user'

export default defineComponent({
  name: 'PostList',
  components: {
    AButton,
    TechnicalShutdown,
    TopLoginBanner,
    PostRespondBanned,
    PostSaved,
    PostListMenu,
    PostCreate,
    ALoader,
    PostOldestList,
    PostNewestList,
    PostBestList,
    PostShowList,
  },
  setup() {
    const { configuration } = useConfiguration()
    return {
      ...usePostCreate(),
      ...useTopic(),
      ...usePostListUiActions(),
      ...usePostsLoader(),
      ...usePostList(),
      ...usePostListMenu(),
      ...useAppState(),
      ...usePostSingleLoader(),
      ...usePostsLoader(),
      ...useSubscribeTopic(configuration.widget.topicId),
      ...useCurrentUser(),
    }
  },
})
